import React, { Component } from 'react';

import ldclient from 'lib/ldclient';
import * as singleSpa from 'single-spa';
import * as ClassicApp from 'singlespa/apps/classic';

import { domReady, initializeLayers } from './doc-init';

const FooterUrls = {
  HELP:
    'http://help.trello.com/article/736-troubleshooting-browser-issues-with-trello',
  CONTACT: '/contact?context=load-failure&source=from%20in%20app%20footer',
};

export class Chrome extends Component {
  constructor(props) {
    super(props);

    domReady();
  }

  componentDidMount() {
    initializeLayers();
    // Tell single-spa that you're ready for it to mount your application to the DOM
    ClassicApp.setElem(document.getElementById('classic'));
    singleSpa.start();
  }

  render() {
    return (
      <React.Fragment>
        <div id="boards-drawer" />
        <p id="notification" />
        <div id="surface">
          <div id="header" />
          <div id="content" />
          <div id="footer">
            <div id="contact-us" style={{ display: 'none' }}>
              If you're having trouble loading Trello,{' '}
              <a href={FooterUrls.HELP} target="support">
                check out our troubleshooting guide
              </a>{' '}
              or{' '}
              <a href={FooterUrls.CONTACT} target="contact">
                contact us
              </a>!
            </div>
            <div id="footer-chrome" style={{ display: 'none' }} />
          </div>
        </div>
        <div className="window-overlay">
          <div className="window">
            <a className="focus-dummy" href="#" />
            <div className="window-wrapper" />
          </div>
        </div>
        <div className="pop-over" />
        <div className="tooltip-container" />
        <div id="clipboard-container" />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./app/scripts/views/chrome/chrome-view.js